/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WalletV2 } from "./WalletV2";
import * as t from "io-ts";

// required attributes
const WalletV2ResponseR = t.interface({});

// optional attributes
const WalletV2ResponseO = t.partial({
  data: WalletV2
});

export const WalletV2Response = t.intersection(
  [WalletV2ResponseR, WalletV2ResponseO],
  "WalletV2Response"
);

export type WalletV2Response = t.TypeOf<typeof WalletV2Response>;
